const Header = {
  init: function () {
    Header.toggle();
    Header.sub_menu();
  },

  toggle: function () {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Toggle dropdown
    $(".languages__toggle").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      btn.toggleClass("languages__toggle-open");
      btn.next().slideToggle(250);
    });
  },

  sub_menu: function () {
    // Submenu functionality
    $(".toggle-submenu").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      var siblings = btn.parent().siblings();

      btn.toggleClass("toggle-submenu-active");
      btn.next().slideToggle(250);

      siblings.children(".sub-menu").slideUp();
      siblings.find("toggle-submenu").removeClass("toggle-submenu-active");
    });
  },
};

export default Header;
